import {
  fetchBanners,
  fetchMarketById,
  fetchPage,
  fetchPageLinks,
  localeToMarketCode,
  PageProps,
} from '@instabox/consumer-web-shared'
import { Stack } from '@instabox/consumer-web-ui'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'

import PageContent from '../../components/PageContent'

export interface DynamicPageProps extends PageProps {}

const DynamicPage: NextPage<DynamicPageProps> = ({ content }) => {
  const {
    query: { slug },
  } = useRouter()
  return (
    <Stack>
      <PageContent content={content} fields={['titles', 'rich_texts']} slug={slug as string} />
    </Stack>
  )
}

export default DynamicPage

export const getStaticProps: GetStaticProps<DynamicPageProps> = async ({ locale, params }) => {
  const slug = params?.slug as string
  const {
    data: { marketById },
  } = await fetchMarketById(localeToMarketCode(locale))
  const page = await fetchPage(locale, slug)
  const pageLinks = await fetchPageLinks(locale)
  const banners = await fetchBanners(locale, slug)

  return {
    props: {
      market: marketById,
      pageLinks,
      banners,
      ...page,
    },
    notFound: !page,
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
